import type { Currency } from '@ps/web-core-enums';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React, { useState } from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import type { FirstWizardValues } from '@swf/first';

import RMFDepositLimitFields from './components/RMFDepositLimitFields/RMFDepositLimitFields';
import RMFDepositLimitsIntroduction from './components/RMFDepositLimitsIntroduction/RMFDepositLimitsIntroduction';

interface Limit {
  previousLimit: number;
  limit: string;
}
interface WizzardValues extends FirstWizardValues {
  rmf: {
    deposit?: {
      currency: Currency;
      daily: Limit;
      monthly: Limit;
      weekly: Limit;
      skip: boolean;
    };
  };
}
const RMFDepositLimit: React.FC = () => {
  const isSGScreenEnabled: boolean = useFeature(FeatureFlag.SwcSGScreen);
  const { values } = useWizardContext();

  const deposit = (values as WizzardValues)?.rmf?.deposit;
  const wasDepositLimitsScreenSkipped = !!deposit?.skip;
  const shouldShowDepositLimit = !wasDepositLimitsScreenSkipped && deposit?.skip !== undefined;

  const [isDepositLimitVisible, setIsDepositLimitVisible] = useState<boolean>(
    !isSGScreenEnabled || shouldShowDepositLimit
  );

  return isDepositLimitVisible ? (
    <RMFDepositLimitFields
      handleBackClick={isSGScreenEnabled ? () => setIsDepositLimitVisible(false) : undefined}
    />
  ) : (
    <RMFDepositLimitsIntroduction setDepositLimits={() => setIsDepositLimitVisible(true)} />
  );
};

RMFDepositLimit.displayName = 'RMFDepositLimit';

export default RMFDepositLimit;
